<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">Data Pengajuan Peserta
    <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Edit</div> -->
    <div class="card-body">
      <div class="card border-0 shadow p-2">
        <div class="card-body row">
          <div class="col-6">
            <form>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name" class="font-weight-bold">Nama Peserta</label>
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Masukkan nama peserta"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="kapa" class="font-weight-bold">Nama Pelatihan</label>
                  <input class="form-control" id="kapa" placeholder="Masukkan nama pelatihan" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="kapa" class="font-weight-bold">Tanggal Pengajuan</label>
                  <input
                    class="form-control"
                    id="kapa"
                    placeholder="Pilih tanggal pelaksanaan"
                    disabled
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12 mb-0">
                  <label for="pos" class="font-weight-bold">SKP Diajukan</label>
                  <p class="font-weight-bold mt-2">SKP IAPI</p>
                </div>
                <div class="form-group col-md-4 mt-n2">
                  <small class="form-text text-muted font-weight-bold">Terstruktur</small>
                  <input
                    type="text"
                    class="form-control"
                    id="pos"
                    placeholder="Terisi sesuai pengajuan"
                    disabled
                  />
                </div>
                <div class="form-group col-md-4 mt-n2">
                  <small class="form-text text-muted font-weight-bold">Non Terstruktur</small>
                  <input
                    type="text"
                    class="form-control"
                    id="fax"
                    placeholder="Terisi sesuai pengajuan"
                    disabled
                  />
                </div>
                <div class="form-group col-md-4 mt-n2">
                  <small class="form-text text-muted font-weight-bold">Assesment</small>
                  <input
                    type="text"
                    class="form-control"
                    id="fax"
                    placeholder="Terisi sesuai pengajuan"
                    disabled
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12 mb-0">
                  <p class="font-weight-bold mt-2">SKP NON IAPI</p>
                </div>
                <div class="form-group col-md-4 mt-n2">
                  <small class="form-text text-muted font-weight-bold">Terstruktur</small>
                  <input
                    type="text"
                    class="form-control"
                    id="pos"
                    placeholder="Terisi sesuai pengajuan"
                    disabled
                  />
                </div>
                <div class="form-group col-md-4 mt-n2">
                  <small class="form-text text-muted font-weight-bold">Non Terstruktur</small>
                  <input
                    type="text"
                    class="form-control"
                    id="fax"
                    placeholder="Terisi sesuai pengajuan"
                    disabled
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="col-6">
            <form>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="name" class="font-weight-bold">Tanggal Pelatihan</label>
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Pilih tanggal pelaksanaan"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="kapa" class="font-weight-bold">Tahun Pelatihan</label>
                  <input class="form-control" id="kapa" placeholder="Terisi Tahun Pelaksanaan" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="pos" class="font-weight-bold">Jenis Pelatihan</label>
                  <input
                    type="text"
                    class="form-control"
                    id="pos"
                    placeholder="Tempat pelatihan akan terisi otomatis dengan penyelenggara"
                    disabled
                  />
                </div>
                <div class="form-group col-md-12">
                  <label for="pos" class="font-weight-bold">Bukti Sertifikat <small><a href="" target="_blank">Lihat Gambar</a></small></label>
                  <div class="custom-file text-truncate">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="validatedCustomFile"
                      @change="fileUpload"
                    />
                    <label class="custom-file-label" data-browse="Unggah" for="validatedCustomFile">{{ fileName }}.</label>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12 mb-0">
                    <label for="pos" class="font-weight-bold">SKP Diajukan</label>
                    <p class="font-weight-bold mt-2">SKP IAPI</p>
                  </div>
                  <div class="form-group col-md-4 mt-n2">
                    <small class="form-text text-muted font-weight-bold">Terstruktur</small>
                    <input
                      type="text"
                      class="form-control"
                      id="pos"
                      placeholder="Masukkan Nilai"                      
                    />
                  </div>
                  <div class="form-group col-md-4 mt-n2">
                    <small class="form-text text-muted font-weight-bold">Non Terstruktur</small>
                    <input
                      type="text"
                      class="form-control"
                      id="fax"
                      placeholder="Masukkan Nilai"
                    />
                  </div>
                  <div class="form-group col-md-4 mt-n2">
                    <small class="form-text text-muted font-weight-bold">Assesment</small>
                    <input
                      type="text"
                      class="form-control"
                      id="fax"
                      placeholder="Masukkan Nilai"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12 mb-0">
                    <p class="font-weight-bold mt-2">SKP NON IAPI</p>
                  </div>
                  <div class="form-group col-md-4 mt-n2">
                    <small class="form-text text-muted font-weight-bold">Terstruktur</small>
                    <input
                      type="text"
                      class="form-control"
                      id="pos"
                      placeholder="Masukkan nilai"
                    />
                  </div>
                  <div class="form-group col-md-4 mt-n2">
                    <small class="form-text text-muted font-weight-bold">Non Terstruktur</small>
                    <input
                      type="text"
                      class="form-control"
                      id="fax"
                      placeholder="Masukkan Nilai"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
      <router-link to="/pelatihan/data-pengajuan-skp">
        <Button class="btn btn-md btn-success px-4 py-2" type="submit" color="success">Simpan</Button>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {};
</script>